<svg :class=componentClassAttribute> <use :xlink:href=xlinkHref></use> </svg>